export default __webpack_public_path__ + "static/media/language_toggle.dc6fff64.gif";